import {
  MonitoringByKind,
  MonitoringByStatus,
  MonitoringCatalog,
  MonitoringApproval,
  MonitoringDemands,
  MonitoringLifetime,
  MonitoringPeriods,
  MonitoringStatusBuckets,
  MonitoringTop,
} from '../Interfaces/monitoring-report.interface';

export const MONITORING_EMPTY_PERIODS: MonitoringPeriods = {
  current: { start: '', end: '' },
  previous: { start: '', end: '' },
};

export const MONITORING_EMPTY_CATALOG: MonitoringCatalog = {
  total: 0,
  applications: 0,
  groups: 0,
};

export const MONITORING_EMPTY_LIFETIME: MonitoringLifetime = {
  average_seconds: null,
  previous_average_seconds: null,
  delta_percent: null,
  sample_count: 0,
};

export const MONITORING_EMPTY_DEMANDS: MonitoringDemands = {
  total: 0,
  previous_total: 0,
  delta_percent: null,
};

export const MONITORING_EMPTY_APPROVAL: MonitoringApproval = {
  rate_percent: null,
  previous_rate_percent: null,
  delta_points: null,
  sample_count: 0,
};

export const MONITORING_EMPTY_BY_KIND: MonitoringByKind = {
  applications: 0,
  groups: 0,
};

const EMPTY_STATUS_BUCKETS: MonitoringStatusBuckets = {
  open: 0,
  approved: 0,
  rejected: 0,
  canceled: 0,
  failed: 0,
};

export const MONITORING_EMPTY_BY_STATUS: MonitoringByStatus = {
  applications: EMPTY_STATUS_BUCKETS,
  groups: EMPTY_STATUS_BUCKETS,
};

export const MONITORING_EMPTY_TOP: MonitoringTop = {
  applications: [],
  groups: [],
  validators: [],
};
